import React from 'react';
import {connect, getStore, setStore} from "trim-redux";
import {Link} from "react-router-dom";
import {AppBar, Badge, Box, Button, Container, Hidden, IconButton, Toolbar, useMediaQuery} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {Menu} from "@mui/icons-material";
import Logo from '../../../../files/img/logo/logo.png'
import LogoSquare from '../../../../files/img/logo/logo-square.png'
import UserMenu from "./UserMenu";
import {ShoppingBag, Heart, Search, LogIn, Headset} from "lucide-react";
import AddressChooserField from "../../address/AddressChooserField";
import BottomNav from "./BottomNav";
import {useTranslation} from "react-i18next";
import MenuTabs from "./MenuTabs";
import HeaderCartIcon from "./items/HeaderCartIcon";
import {theme} from "../../../../config/design/theme";
import AddressChooserBtn from "../../address/AddressChooserBtn";
import Notifications from "../Notifications";
import {getDesktopRedirectPath, isDesktopApp} from "../../../../config/desktopApp";
const AppHeader = (props) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const logoPath = isDesktopApp() ? getDesktopRedirectPath() : '/';

    return (
        <>
            <AppBar className={props.classes.appbar} color='inherit'>
                <Toolbar style={{padding:0}}>
                    <Container maxWidth="xl" className={props.classes.appToolbar}>
                        <div style={{display:"flex",alignItems:"center",gap:30}}>
                            <Box style={{
                                cursor: "pointer",
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'center',
                            }}
                                 component={Link}
                                 to={logoPath}
                            >
                                <img
                                    className={isMobile ? props.classes.LayoutLogoMobile : props.classes.LayoutLogo}
                                    src={isMobile ? LogoSquare : Logo}
                                    alt={getStore('app_name')}
                                />
                            </Box>
                            <Hidden mdDown>
                                <MenuTabs/>
                            </Hidden>
                        </div>

                        <div style={{display:"flex",alignItems:"center",gap:isMobile ? 2 : 10}}>

                            <AddressChooserBtn clName="top-menu"/>

                            {
                                !!props.user ?
                                <>


                                    <Hidden mdDown>
                                    <UserMenu/>

                                    <IconButton component={Link} to={'/wishlist'}>
                                        <Heart className="lucide-icon-text"/>
                                    </IconButton>
                                </Hidden>
                                    <HeaderCartIcon/>
                                    <Notifications/>
                                    <Hidden mdUp>
                                        <Badge badgeContent={props.user?.umc} color="secondary" className="header-cart-badge">
                                            <IconButton component={Link} to={'/account/support'}>
                                                <Headset className="lucide-icon-text" />
                                            </IconButton>
                                        </Badge>
                                    </Hidden>
                                </>
                                :
                                    <div>
                                        {
                                            !!isMobile ?
                                                <IconButton
                                                    component={Link}
                                                    to={'/login'}
                                                    color="default"
                                                >
                                                    <LogIn className="lucide-icon btn"/>
                                                </IconButton>
                                                :
                                                <Button
                                                    component={Link}
                                                    to={'/login'}
                                                    color="default"
                                                    startIcon={<LogIn className="lucide-icon btn"/> }
                                                >
                                                    {t("loginRegister")}
                                                </Button>
                                        }

                                    </div>

                            }

                        </div>
                    </Container>
                </Toolbar>
                {
                    !!props.has_global_menu &&
                    <Hidden mdUp>
                        <Toolbar style={{backgroundColor:"#f9f9f9"}}>
                            <MenuTabs style={{width:"100%"}}/>
                        </Toolbar>
                    </Hidden>
                }

            </AppBar>
            <Hidden mdUp>
                <BottomNav/>
            </Hidden>
        </>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    has_global_menu: state.has_global_menu,

});
export default withStyles(Styles)(connect(mstp)(AppHeader));
